<template>
    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on:dialog }">
            <v-tooltip top>
                <template v-slot:activator="{ on:tooltip }">
                    <v-btn color="primary"
                           x-small
                           fab
                           class="mx-2"
                           depressed
                           v-on="{...dialog, ...tooltip}"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <span>Редактировать абонемент</span>
            </v-tooltip>
        </template>
        <v-card class="modal-card">
            <v-card-title class="pa-6">Редактировать абонемент</v-card-title>
            <v-card-text class="pa-6">
                <ValidationObserver ref="form" tag="div">
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <ValidationProvider name="card_type_id"
                                                rules="required"
                                                v-slot="{ errors }"
                                                tag="div"
                                                class="client-info-group">
                                <v-autocomplete
                                        v-model="cardType"
                                        :items="cardTypes"
                                        item-text="name"
                                        :return-object="true"
                                        required
                                        label="Вид абонемента"
                                        @change="onCardTypeChange"
                                        outlined
                                        :error-messages="errors"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <ValidationProvider name="visits_limit"
                                                v-slot="{ errors }"
                                                tag="div"
                                                class="client-info-group">
                                <v-text-field
                                        type="number"
                                        v-model="visits_limit"
                                        required
                                        label="Количество посещений"
                                        outlined
                                        hint="Поставить 0 или оставить пустым если нет лимита"
                                        persistent-hint
                                        :error-messages="errors"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" class="pb-0">
                            <v-menu
                                    v-model="startAtPicker"
                                    :close-on-content-click="false"
                                    :nudge-right="0"
                                    :nudge-top="25"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{on}">
                                    <v-text-field
                                            v-model="start_at"
                                            label="Действителен с"
                                            append-icon="mdi-calendar-month"
                                            readonly
                                            required
                                            v-on="on"
                                            outlined
                                    />
                                </template>
                                <v-date-picker
                                        v-model="start_at"
                                        locale="ru-RU"
                                        @input="startAtPicker = false"
                                        first-day-of-week="1"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" class="pb-0">
                            <v-menu
                                    v-model="endAtPicker"
                                    :close-on-content-click="false"
                                    :nudge-right="0"
                                    :nudge-top="25"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{on}">
                                    <v-text-field
                                            v-model="end_at"
                                            label="Действителен по"
                                            append-icon="mdi-calendar-month"
                                            readonly
                                            required
                                            v-on="on"
                                            outlined
                                    />
                                </template>
                                <v-date-picker
                                        v-model="end_at"
                                        locale="ru-RU"
                                        @input="endAtPicker = false"
                                        first-day-of-week="1"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </ValidationObserver>
            </v-card-text>
            <v-card-actions class="px-6 py-5">
                <v-spacer></v-spacer>
                <v-btn depressed dark color="blue-grey" @click="close" min-width="120" class="mx-2">Закрыть</v-btn>
                <v-btn depressed color="success" @click="save" min-width="120">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import cardApi from '../api/card.api';
    import dayjs from 'dayjs';
    import {mapState} from "vuex";

    export default {
        name    : "CardEditDialog",
        props   : {
            card: {
                required: true,
                type    : Object,
            }
        },
        data() {
            return {
                dialog: false,

                visits_limit: null,
                start_at    : null,
                end_at      : null,

                startAtPicker: false,
                endAtPicker  : false,

                cardTypeId: null,
            };
        },
        computed: {
            ...mapState({
                cardTypes: state => state['card-types'].items,
            }),
            cardType: {
                get() {
                    return this.cardTypes.find(cardType => cardType.id == this.cardTypeId);
                },
                set(value) {
                    this.cardTypeId = value.id;
                }
            }
        },
        watch   : {
            dialog() {
                if (true === this.dialog) {
                    this.start_at = this.card.start_at;
                    this.end_at = this.card.end_at;
                }
            }
        },
        mounted() {
            this.visits_limit = this.card.visits_limit;
            this.cardTypeId = this.card.card_type_id;
        },
        methods : {
            onCardTypeChange() {
                this.visits_limit = this.cardType.visits_limit;
                this.end_at = dayjs(this.start_at, 'YYYY-MM-DD').add(this.cardType.duration, this.cardType.duration_unit).format('YYYY-MM-DD');
            },
            save() {
                cardApi.update(this.card.id, {
                    card_type_id: this.cardType ? this.cardType.id : null,
                    visits_limit: this.visits_limit,
                    start_at    : this.start_at,
                    end_at      : this.end_at,
                }).then(() => {
                    this.$store.dispatch('clients/refresh');
                    this.$emit('saved');
                }).catch(({response}) => {
                    this.$refs.form.setErrors(response.data.errors);
                }).finally(() => {
                    this.close();
                })
            },
            close() {
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>
